import React from "react"

export function isReactPlaceholder(child: React.ReactNode) {
  return child === true || child === false || child === null || child === undefined
}
